var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOnboarding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3496_5232)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#E6E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7136 5.77836C13.2322 5.50752 12.8349 5.23947 12.5448 5.02684C12.2189 4.78842 11.7811 4.78842 11.4552 5.02684C10.605 5.64904 8.83813 6.75052 6.71742 6.9893C6.25069 7.04158 5.90002 7.44035 5.90002 7.90987V11.3088C5.90002 12.0959 6.02063 13.0639 6.418 14.0817",
    stroke: "#F8009E",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34003 16.917C9.15255 17.6985 10.222 18.4374 11.6236 19.0715C11.8613 19.1788 12.1391 19.1788 12.3768 19.0715C17.2209 16.88 18.1 13.4347 18.1 11.3088V7.90988C18.1 7.44036 17.7494 7.04159 17.2826 6.98896C16.9937 6.95654 16.7113 6.90774 16.437 6.84674",
    stroke: "#F8009E",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34003 16.7957C8.34003 15.4537 9.43803 14.3557 10.78 14.3557H13.22C13.8415 14.3557 14.4104 14.5909 14.8423 14.9772",
    stroke: "#F8009E",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0829 10.6956C10.0829 9.63669 10.9411 8.7785 12 8.7785C13.059 8.7785 13.9172 9.63669 13.9172 10.6956C13.9172 11.7546 13.059 12.6128 12 12.6128C11.8596 12.6128 11.7229 12.5978 11.5912 12.5692",
    stroke: "#F8009E",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3496_5232"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOnboarding);
export default __webpack_public_path__ + "static/media/icon-onboarding.ff7d532ecca5cc2b0e04535bcd9ead4d.svg";
export { ForwardRef as ReactComponent };